import { query } from "sinao-corejs";

const app = {
	state: () => ({
		id: null,
		token: null, // For the embed mode
		documentId: null,
		app: null,
		rights: null,
		apiUrl: null,
		apiKey: null,
		utm: {
			utm_source: "google",
			utm_medium: "cpc",
			utm_campaign: "editeur-gratuit"
		},
        branding: null,
        MAX_SUGGESTIONS: 30
	}),
	getters: {
		organization(state) {
			return state?.app?.organization;
		},
		establishments(state) {
			return [state?.app?.organization?.headquarters];
		},
		hasAccessToCurrencies(state) {
			return state.rights?.includes("!app.documents.sales.multicurrencies") ? false : true;
		},
        isWhiteLabel(state) {
            const hostname = state.app.hostname_alias ?? "sinao.app";
            return hostname !== "sinao.app";
        },
        canLinkSinaoHelpCenter(state, getters) {
            const appName = state.branding?.name?.toLowerCase() ?? "sinao";
            const is_mb =  getters.isWhiteLabel && appName !== "sinao";
            return !is_mb;
        }
	},
	mutations: {
		organization(state, payload) {
			state.app.organization = payload;
		},
		apiUrl(state, payload) {
			state.apiUrl = payload;
		},
		apiKey(state, payload) {
			state.apiKey = payload;
		},
		id(state, payload) {
			state.id = payload;
		},
		token(state, payload) {
			state.token = payload;
		},
		documentId(state, payload) {
			state.documentId = payload;
		},
		app(state, payload) {
			state.app = payload;
		},
		rights(state, payload) {
			state.rights = payload;
		},
		headquartersProperty(state, { propertyName, propertyValue }) {
			if (!state?.app?.organization?.headquarters) return console.log("no organization to set");
			state.app.organization.headquarters[propertyName] = propertyValue;
		},
		headquartersPlaceProperty(state, { propertyName, propertyValue }) {
			if (!state?.app?.organization?.headquarters) return console.log("no organization to set");
			state.app.organization.headquarters.place[propertyName] = propertyValue;
			state.app.organization.headquarters.place.formatted_address = state.app.organization.headquarters.place.route
				+ " - "
				+ state.app.organization.headquarters.place.route2
				+ " - "
				+ state.app.organization.headquarters.place.postal_code
				+ " - "
				+ state.app.organization.headquarters.place.locality
				+ " - "
				+ state.app.organization.headquarters.place.country;
		},
		headquartersPhonesProperty(state, { phoneValue }) {
			if (!state?.app?.organization?.headquarters) return console.log("no organization to set");
			state.app.organization.headquarters.phones.splice(0, 1, phoneValue);
		},
		headquartersEmailsProperty(state, { emailValue }) {
			if (!state?.app?.organization?.headquarters) return console.log("no organization to set");
			state.app.organization.headquarters.emails.splice(0, 1, emailValue);
		},
		organizationProperty(state, { propertyName, propertyValue }) {
			if (!state?.app?.organization) return console.log("no organization to set");
			state.app.organization[propertyName] = propertyValue;
		},
        branding(state, payload) {
            state.branding = payload;
        }
	},
	actions: {
		async updateUTM(_, { appId, token, utm }) {
			return query({
				operationId: "app.settings.update",
				token,
				params: {
					appId
				},
				data: {
					settings: {
						...utm
					}
				}
			});
		},
		async app({ commit }, appId) {
			try {
				const response = await query({
					operationId: "app.get",
					params: {
						appId,
						"expand[0]": "subscription",
						"expand[1]": "organization.needEmailBcc",
						"expand[2]": "config_sample"
					}
				});

				commit("app", response);
				commit("rights", response?.subscription?.plan?.rights);
				commit("defaultConfig", response?.config_sample)

				return response;
			} catch (error) {
				throw new Error(error);
			}
		}
	}
};

export default app;
